export { default } from './CoursesModal.jsx';